import React from 'react';
import PropTypes from 'prop-types';
import DayView from '../../../components/dayView/DayView';

const OverviewAttendanceRequest = ({ selectedData }) => {
  return (
    <div className="border border-1 rounded-4 p-2">
      <table>
        <tbody>
          <tr>
            <td style={{ verticalAlign: 'top', padding: '3px' }}>Nama Karyawan</td>
            <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
            <td
              style={{
                verticalAlign: 'top',
                padding: '3px',
                fontWeight: '500',
                width: '300px',
              }}
            >
              {selectedData?.employee_name}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: 'top', padding: '3px' }}>Tipe Pengajuan</td>
            <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
            <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
              {selectedData?.request_type_name !== null ? selectedData?.request_type_name : '-'}
            </td>
          </tr>
          {selectedData?.request_type_code === 'UNP' && (
            <tr>
              <td style={{ verticalAlign: 'top', padding: '3px' }}>Alasan</td>
              <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
              <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
                {selectedData?.unplanned_reason_name}
              </td>
            </tr>
          )}
          <tr>
            <td style={{ verticalAlign: 'top', padding: '3px' }}>Jam Masuk</td>
            <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
            <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
              {selectedData?.clock_in !== null ? `${selectedData?.clock_in} WIB` : '-'}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: 'top', padding: '3px' }}>Jam Pulang</td>
            <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
            <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
              {selectedData?.clock_out !== null ? `${selectedData?.clock_out} WIB` : '-'}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: 'top', padding: '3px' }}>Keterangan</td>
            <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
            <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
              <i>{`'${selectedData?.description}'`}</i>
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: 'top', padding: '3px' }}>Lampiran</td>
            <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
            <td style={{ verticalAlign: 'top', padding: '3px' }}>
              {selectedData?.attachment !== null ? (
                <div className="border border-1 rounded-4">
                  <img
                    src={selectedData?.attachment}
                    alt="attachment"
                    width="300"
                    height="auto"
                    className="rounded-4"
                  />
                </div>
              ) : (
                'Tidak ada lampiran.'
              )}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: 'top', padding: '3px', width: '120px' }}>Diajukan pada</td>
            <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
            <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
              <DayView date={selectedData?.created_at} time block />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

OverviewAttendanceRequest.propTypes = {
  selectedData: PropTypes.object,
};

export default OverviewAttendanceRequest;
